export const worksData = [
  {
    companyName: "XAM Consulting",
    workDateStart: "Mar 2022",
    workDateEnd: "present",
    position: "Senior Developer",
    companyLink: "https://xam.com.au/",
  },
  {
    companyName: "Accenture Philippines",
    workDateStart: "Apr 2020",
    workDateEnd: "Mar 2022",
    position: "Senior Application Developer",
    companyLink: "https://www.accenture.com/ph-en",
  },
  {
    companyName: "Tensei Philippines Inc.",
    workDateStart: "Jun 2019",
    workDateEnd: "Apr 2020",
    position: "Systems Engineer (Team Lead)",
    companyLink: "https://www.tenseiph.com/",
  },
  {
    companyName: "Tensei Data Net Inc.",
    workDateStart: "Jan 2017",
    workDateEnd: "May 2019",
    position: "Systems Engineer - Trainee (Fukui, Japan)",
    companyLink: "https://www.tenseidatanet.co.jp/",
  },
  {
    companyName: "Tensei Philippines Inc.",
    workDateStart: "Aug 2016",
    workDateEnd: "Jan 2017",
    position: "Web Developer",
    companyLink: "https://www.tenseiph.com/",
  },
];

export const skillsData = [
  {
    name: "HTML & CSS",
    nameValue: 75,
    grade: "90%",
    gradeValue: 10,
    skillType: "frontend",
  },
  {
    name: "Vanilla JS",
    nameValue: 75,
    grade: "90%",
    gradeValue: 10,
    skillType: "frontend",
  },
  {
    name: "React JS",
    nameValue: 75,
    grade: "90%",
    gradeValue: 10,
    skillType: "frontend",
  },
  {
    name: "Redux",
    nameValue: 65,
    grade: "80%",
    gradeValue: 20,
    skillType: "frontend",
  },
  {
    name: "RTK Query",
    nameValue: 55,
    grade: "70%",
    gradeValue: 30,
    skillType: "frontend",
  },
  {
    name: "TypeScript",
    nameValue: 65,
    grade: "80%",
    gradeValue: 20,
    skillType: "frontend",
  },
  {
    name: "Vue JS",
    nameValue: 45,
    grade: "60%",
    gradeValue: 40,
    skillType: "frontend",
  },
  {
    name: "SCSS",
    nameValue: 65,
    grade: "80%",
    gradeValue: 20,
    skillType: "frontend",
  },
  {
    name: "Bootstrap",
    nameValue: 65,
    grade: "80%",
    gradeValue: 20,
    skillType: "frontend",
  },
  {
    name: "Reactstrap",
    nameValue: 65,
    grade: "80%",
    gradeValue: 20,
    skillType: "frontend",
  },
  {
    name: "jQuery",
    nameValue: 55,
    grade: "70%",
    gradeValue: 30,
    skillType: "frontend",
  },
  {
    name: "Core UI",
    nameValue: 55,
    grade: "70%",
    gradeValue: 30,
    skillType: "frontend",
  },
  {
    name: "Ionic UI",
    nameValue: 35,
    grade: "50%",
    gradeValue: 50,
    skillType: "frontend",
  },
  {
    name: "Material UI",
    nameValue: 55,
    grade: "70%",
    gradeValue: 30,
    skillType: "frontend",
  },
  {
    name: "PHP",
    nameValue: 65,
    grade: "80%",
    gradeValue: 20,
    skillType: "backend",
  },
  {
    name: "Laravel",
    nameValue: 65,
    grade: "80%",
    gradeValue: 20,
    skillType: "backend",
  },
  {
    name: "Express JS",
    nameValue: 45,
    grade: "60%",
    gradeValue: 40,
    skillType: "backend",
  },
  {
    name: "Node JS",
    nameValue: 45,
    grade: "60%",
    gradeValue: 40,
    skillType: "backend",
  },
  {
    name: "MySQL",
    nameValue: 65,
    grade: "80%",
    gradeValue: 20,
    skillType: "backend",
  },
  {
    name: "MongoDB",
    nameValue: 45,
    grade: "60%",
    gradeValue: 40,
    skillType: "backend",
  },
  {
    name: "Firebase",
    nameValue: 65,
    grade: "80%",
    gradeValue: 20,
    skillType: "backend",
  },
  {
    name: "JAVA",
    nameValue: 45,
    grade: "60%",
    gradeValue: 40,
    skillType: "backend",
  },
  {
    name: "English",
    nameValue: 65,
    grade: "80%",
    gradeValue: 20,
    skillType: "others",
  },
  {
    name: "Nihongo",
    nameValue: 65,
    grade: "80%",
    gradeValue: 20,
    skillType: "others",
  },
  {
    name: "Jest",
    nameValue: 65,
    grade: "80%",
    gradeValue: 20,
    skillType: "testing",
  },
  {
    name: "Enzyme",
    nameValue: 65,
    grade: "80%",
    gradeValue: 20,
    skillType: "testing",
  },
  {
    name: "RTL",
    nameValue: 65,
    grade: "80%",
    gradeValue: 20,
    skillType: "testing",
  },
  {
    name: "Cucumber",
    nameValue: 65,
    grade: "80%",
    gradeValue: 20,
    skillType: "testing",
  },
  {
    name: "Gherkins",
    nameValue: 65,
    grade: "80%",
    gradeValue: 20,
    skillType: "testing",
  },
  {
    name: "PHPUnit",
    nameValue: 55,
    grade: "70%",
    gradeValue: 30,
    skillType: "testing",
  },
];
